import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lxk: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {
        getLxk(state) {
            let lxk = { ...state.lxk }
            lxk.lxkqtdzero = lxk.lxkqtdzero == null ? 0 : Number(lxk.lxkqtdzero)
            lxk.lxkultlote = lxk.lxkultlote == null ? 0 : Number(lxk.lxkultlote)
            return lxk;
        }
    },
    mutations: {
        set(state, lxk){
            state.lxk = lxk
            if (lxk)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/OryxPlace/InputParameters/Find")
            .then(response => {
                let lxk = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", lxk)
                return lxk
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
            return true
        },
        save(store){
            if (store.state.update){
                return store.dispatch("update")
            }
            return store.dispatch("insert")
        },
        async insert({ getters, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            const payload = await this._vm.$axios.post("/OryxPlace/InputParameters/Insert", getters.getLxk)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                dispatch("find")
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
            return payload
        },
        async update({ getters, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            const payload = await this._vm.$axios.put("/OryxPlace/InputParameters/Update", getters.getLxk )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                dispatch("find")
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
            return payload
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/OryxPlace/InputParameters/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}
